module.exports = __webpack_public_path__ + "assets/img/effective4.8fa4d12e.png";